import React, { VFC } from 'react';
import { Trans, useTranslation } from 'react-i18next';

type Props = {
  stringKey: string;
  values?: any;
  shouldUnescape?: boolean;
};

export const TranslationComponent: VFC<Props> = ({ stringKey, values, shouldUnescape }) => {
  const { t } = useTranslation();

  return (
    <Trans t={t} values={values} shouldUnescape={shouldUnescape}>
      {t(stringKey)}
    </Trans>
  );
};
